const getAbsoluteUrl = (url) => url.substring(0, 5).includes("http") ? url : "http://" + url;
const buildUrl = (videoUrl) => {
  const baseUrl = typeof location !== "undefined" && location.hostname === "editor.wix.com" ? "https://editor.wix.com/rich-content/oembed" : "https://www.wixapis.com/ricos/v1/oembeds";
  const url = new URL(baseUrl);
  url.searchParams.append("url", getAbsoluteUrl(videoUrl));
  url.searchParams.append("options.maxWidth", "980");
  return url;
};
const fetchOembed = async (url, instance) => {
  const res = await fetch(buildUrl(url), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: instance
    }
  });
  return res.json();
};
const fetchOembedWithAuth = async (url, makeRequest) => {
  const res = await makeRequest(buildUrl(url), {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  });
  return res.json();
};
const providerBlackList = ["wix", "facebook"];
const fetchEmbedData = (instance) => async (url) => {
  try {
    return fetchOembed(url, instance).then((json) => {
      const { html, ...rest } = json;
      const { provider_name } = rest;
      const res = providerBlackList.includes((provider_name || "").toLowerCase()) ? { ...rest } : { ...rest, html };
      return res;
    });
  } catch {
    return new Promise((resolve) => {
      setTimeout(() => resolve({}), 1);
    });
  }
};
export {
  fetchEmbedData,
  fetchOembed,
  fetchOembedWithAuth
};
//# sourceMappingURL=fetch-embed-data.js.map
